module.exports = __webpack_public_path__ + "static/media/greyArrowLeft.f9984de6.svg";